import { LegendContainer, LegendIcon } from './ADHPTool.styles'

interface LegendProps {
  meaning: string
  icon: string
  place: number
  legendsLength: number
  isNavaid?: boolean
}

export function Legend(props: LegendProps) {
  const { meaning, icon, place, legendsLength, isNavaid } = props

  return (
    <LegendContainer legendsLength={legendsLength} place={place}>
      <LegendIcon src={icon} alt={meaning} isNavaid={isNavaid} />
      <p>{meaning}</p>
    </LegendContainer>
  )
}
